import "./index.css";

export const Instantaneos = () => {
  return (
    <div className="container">
      <div className="indicator">
        <h1>Administrar Instantaneos</h1>
      </div>
    </div>
  );
};
